import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState, useRef } from "react";
import './UserActivityPanel.css';
import moment from "moment";
import config from "../../../config";
import { useDispatch, useSelector } from 'react-redux';
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import Pagination from 'react-js-pagination';
import ReactToPrint from "react-to-print";
import HelpdeskApiCall from 'HelpdeskApiCall';
import { X } from 'lucide-react'


function UserActivityPanel(props) {

    let shouldWait = false;
    let scrollBuffer = 0;

    const [showPanel, setShowPanel] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [limit, setLimit] = useState(10);
    const [pageIndex, setPageIndex] = useState(1);
    const [offset, setOffset] = useState(0);
    const [read, setRead] = useState(false);
    const [operation, setOperation] = useState("");
    const [sortedIdArray, setSortedIdArray] = useState([]);
    const [selectedIdArray, setSelectedIdArray] = useState([]);
    const [totalCount, setTotalCount] = useState([]);
    const [userActivityFromDate, setUserActivityFromDate] = useState([]);
    const [userActivityToDate, setUserActivityToDate] = useState([]);
    const [moduleName, setModuleName] = useState([]);
    const [moduleId, setModuleId] = useState([]);
    const [moduleList, setModuleList] = useState([]);
    const [instituteIdArray, setInstituteIdArray] = useState([]);
    const [isExporting, setIsExporting] = useState(false);
    const dispatch = useDispatch();
    const AdminAccessInstituteArray = useSelector((state) => state?.RouteMenuReducer?.assignedIIDArray || []);
    const componentRef = useRef();

    const [UserActivityList, setUserActivityList] = useState([]);
    // const [unReadMessageCount, setUnReadMessageCount] = useState([]);
    const modalRef = useRef(null); // Create a ref for the modal

    const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            props.handleModalOpenClose('userActivity')
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside); // Cleanup on unmount
        };
    }, []);

    useEffect(() => {

        apiCallToGetPMInstituteModuleList();
        // apiCallToGetUserActivityList();
        GetInstructorAssignedInstituteList();
    }, []);


    const GetInstructorAssignedInstituteList = async () => {
        const requestData = {
            facultyId: config.faculty_id,
        };
        try {
            const jsonResponse = await HelpdeskApiCall.makeApiCall(
                'GetInstructorAssignedInstituteList',
                requestData,
                "/api/management/management.php"
            );
            if (jsonResponse.expired) {
                setTimeout(() => {
                    GetInstructorAssignedInstituteList();
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    const iidArray = Object.keys(jsonResponse.APIResult.data);
                    setInstituteIdArray(iidArray);
                }
            }
        } catch (error) {
            console.error('Error fetching instructor assigned institute list:', error);
        }
    };

    useEffect(() => {
        apiCallToGetUserActivityList();
    }, [moduleId, userActivityFromDate, userActivityToDate, operation, limit]);

    // FUNCTION TO LOAD MORE
    let loadMore = () => {
        setLimit((prev) => prev + 10);
    }


    const clickToExport = () => {
        setIsExporting(true); // Start export process
        document.getElementById('export-excel').click();
        setTimeout(() => {
            setIsExporting(false); // Reset after export
          }, 2000); // Simulated delay
    };


    const resetUserList = (e) => {
        const newItemsPerPage = parseInt(e.target.value, 10);
        setLimit(newItemsPerPage);
        setPageIndex(1);
    };

    const apiCallToGetPMInstituteModuleList = async () => {
        let formData = {

        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            "GetPMInstituteModuleList",
            formData,
            '/api/projectManagement/settings/moduleInformation.php'
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetPMInstituteModuleList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                setModuleList(apiResult);
            } else {
                setIsLoading(true);
            }
        }


    }



    //  API CALL TO GET NOTIFICATION
    const apiCallToGetUserActivityList = async () => {

        setIsLoading(true);
        let formData = {
            iid: config.institute_id,
            user_role: "employee", //config.instructorRole == "instructor" || config.instructorRole == "employee" || config.instructorRole == "teaching" || config.instructorRole == "nonteaching" ? "employee" : "learner",
            user_id: config.faculty_id,
            page_index: pageIndex,
            limit: limit,
            iidArray: props.instituteIdArray,
            filterFromDate: userActivityFromDate,
            filterToDate: userActivityToDate,
            module_id: moduleId,
            operation
        };
    
       

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            "GetUserActivityLogs",
            formData,
            '/api/user_activity_logs.php'
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetUserActivityList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                // let unReadMessageCount = jsonResponse.APIResult.unReadMessageCount;
                let totalCount = jsonResponse.APIResult.total;
                // setUnReadMessageCount(unReadMessageCount);
                setUserActivityList(apiResult);
                setIsLoading(false);
                setSortedIdArray(jsonResponse.APIResult.sortedIdArray);
                setTotalCount(totalCount);
                setSelectedIdArray([]);
            } else {
                setIsLoading(true);
            }
        }


    }

    //  API CALL TO UPDATE NOTIFICATION
    const apiCallToUpdateUserActivity = async (uniqueId) => {
        if (!selectedIdArray.includes(uniqueId)) {
            setSelectedIdArray([...selectedIdArray, uniqueId]);
        }

        let formData = {
            iid: config.institute_id,
            uniqueId: uniqueId,
            userId: config.faculty_id,
        };
        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            "webNotificationUpdateNotification",
            formData,
            '/api/webNotification/webNotification.php'
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToUpdateUserActivity();
            }, 1000);
        } else {
            if (jsonResponse.success) {

                let apiResult = jsonResponse.APIResult;

                apiCallToGetUserActivityList();
            }
        }

    }

    const userActivitySelected = (uniqueId) => {
        if (!selectedIdArray.includes(uniqueId)) {
            setSelectedIdArray([...selectedIdArray, uniqueId]);
        }
        apiCallToGetUserActivityList();
    }

    useEffect(() => {

        if (props.ActivityLogModal != showPanel) {

            setShowPanel(props.ActivityLogModal)
        }
    }, [props.ActivityLogModal]);


    const setFromUserActivityDate = (e) => {
        let dayDifferenceValue = 1 + moment(userActivityToDate).diff(moment(e.target.value), 'days');

        setUserActivityFromDate(e.target.value);
        setUserActivityToDate('');
        apiCallToGetUserActivityList();
    };


    const setToUserActivityDate = (e) => {
        let dayDifferenceValue = 1 + moment(e.target.value).diff(moment(userActivityFromDate), 'days');

        setUserActivityToDate(e.target.value);
        apiCallToGetUserActivityList();
    };



    // METHOD TO SELECT FILTER Academic Branch
    const selectFilterModule = (e) => {
        setModuleId(e.target.value)
        setPageIndex(1)
        // setOffset(0)
        setLimit(10);
        // apiCallToGetUserActivityList();
    }

    const selectFilterOperation = (e) => {
        setOperation(e.target.value)
        setPageIndex(1)
        // setOffset(0)
        setLimit(10);
    }

    // This effect runs when pageIndex updates
    useEffect(() => {
        if (pageIndex !== null) { // Prevents unnecessary API calls on mount
            apiCallToGetUserActivityList();
        }
    }, [pageIndex]);

    const updatePaginationCount = (num) => {
        // setOffset((pageNumber - 1) * limit);
        // setLimit(10);
        setPageIndex((prev) => {
            return num;
        });

        setIsLoading(false);



    };

    const getFirstCharOfWords = (inputString) => {
        const wordsArray = inputString.split(' ');
        const firstCharsArray = wordsArray.map((word) => word.charAt(0));
        const result = firstCharsArray.join('');
        return result;
    }

    return (
        <div className={props.ActivityLogModal ? "modal fade in" : "modal fade"} id="modalContainer" style={{ display: props.ActivityLogModal ? 'block' : 'none' }}>
            <div className="modal-content workspace-current-modal-mode activity-mobile-mode"
                style={{
                    position: "absolute",
                    top: "3rem",
                    right: "0",
                    padding: '20px',
                    zIndex: 9999,
                    width: '65vw',
                    minWidth: '65vw',
                    height: "calc(100vh - 4rem)", // Takes remaining height
                    overflowY: 'auto',
                    // littlebit box shadow so it will look like float
                    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.2)',

                }}
                ref={modalRef}

            >
                <div style={{ display: 'flex', justifyContent: "space-between" }}>
                    <span className="font-weight-bold">Activities</span>
                    <div className="d-flex align-items-center justify-content-between gap-5">
                        <span style={{ display: 'none' }}>
                            <ReactHTMLTableToExcel
                                id="export-excel"
                                className="download-table-xls-button"
                                table="UserActivityData"
                                filename="UserActivityDataTable.csv"
                                sheet="tablexls"
                                buttonText="Export to Excel"
                            />
                        </span>
                        <FontAwesomeIcon title="Click to export activity log" className="export-icon mr-2" style={{ cursor: 'pointer', height: '18px', width: '18px' }} icon={['fas', 'file-excel']} size="mf" onClick={() => clickToExport()} />

                        <ReactToPrint
                            trigger={() =>
                                <FontAwesomeIcon
                                    title="Click to print"
                                    icon={['fas', 'print']}

                                    style={{ cursor: "pointer", height: '18px', width: '18px' }}
                                    className="mr-2 print"
                                    onClick={() => this.setState({
                                    })}
                                />
                            }
                            content={() => componentRef.current}
                        />
                        <div className="config-icon-background-rounded cursor-pointer" onClick={() => props.handleModalOpenClose("userActivity")}>
                            <X size={18} />
                        </div>
                    </div>



                </div>



                <div className="user-activity-container workspace-current-modal-mode" style={{ padding: '8px' }}>

                    {/* Based On Start Date */}
                    <div className="grid-item">
                        <label htmlFor="taskID" className="vm_custom_body10" >From Date</label>
                        <input
                            className="form-control formControlAutoTask ws-app-theme-color-20"
                            style={{
                                width: 'auto',
                                height: '42px',
                                fontSize: "13px",
                                fontWeight: 400,
                                lineHeight: '20px',
                                fontFamily: "'Poppins', sans-serif",
                                color: '#808080',
                                borderRadius: '7px'
                            }}
                            type="date"
                            placeholder="Enter from date."
                            value={userActivityFromDate}
                            onChange={(e) => setFromUserActivityDate(e)}
                        />
                    </div>

                    {/* Start Date */}
                    <div className="grid-item">
                        <label htmlFor="startDate" className="vm_custom_body10">To Date</label>
                        <input
                            className="form-control formControlAutoTask ws-app-theme-color-20"
                            style={{
                                width: 'auto',
                                height: '42px',
                                fontSize: "13px",
                                fontWeight: 400,
                                lineHeight: '20px',
                                fontFamily: "'Poppins', sans-serif",
                                color: '#808080',
                                borderRadius: '7px'
                            }}
                            type="date"
                            placeholder="Enter from date."
                            min={userActivityFromDate}
                            value={userActivityToDate}
                            onChange={(e) => setToUserActivityDate(e)}
                        />
                    </div>

                    {/* Based on task Status */}
                    <div className="grid-item">
                        <label htmlFor="taskID" className="vm_custom_body10">Module</label>
                        <div className="input-group input-group-field" style={{ position: 'relative' }}>
                            <select
                                className="form-control ws-app-theme-color-20"
                                value={moduleId}
                                onChange={(e) => selectFilterModule(e)}
                                style={{
                                    width: 'auto',
                                    height: '42px',
                                    fontSize: "13px",
                                    fontWeight: 400,
                                    lineHeight: '20px',
                                    fontFamily: "'Poppins', sans-serif",
                                    color: '#808080',
                                    borderRadius: '7px'
                                }}
                            >
                                <option
                                    style={{
                                        width: 'auto',
                                        height: '42px',
                                        fontSize: "13px",
                                        fontWeight: 400,
                                        lineHeight: '20px',
                                        fontFamily: "'Poppins', sans-serif",
                                        color: '#808080',
                                        borderRadius: '7px'
                                    }}
                                    value="">Select Module</option>
                                {
                                    Object.keys(moduleList).length > 0 &&
                                    Object.values(moduleList).map(module => {
                                        return (
                                            <option key={module.moduleId} value={module.moduleId}>{module.module_name}</option>
                                        );
                                    })
                                }
                            </select>
                        </div>
                    </div>

                    {/* Based on task Priority */}
                    <div className="grid-item">
                        <label htmlFor="taskID" className="vm_custom_body10">Operation</label>
                        <div className="input-group input-group-field" style={{ position: 'relative' }}>
                            <select
                                className="form-control formControlContentTask ws-app-theme-color-20"
                                value={operation}
                                onChange={(e) => selectFilterOperation(e)}
                                style={{
                                    width: 'auto',
                                    height: '42px',
                                    fontSize: "13px",
                                    fontWeight: 400,
                                    lineHeight: '20px',
                                    fontFamily: "'Poppins', sans-serif",
                                    color: '#808080',
                                    borderRadius: '7px'
                                }}
                            >
                                <option
                                    style={{
                                        width: 'auto',
                                        height: '42px',
                                        fontSize: "13px",
                                        fontWeight: 400,
                                        lineHeight: '20px',
                                        fontFamily: "'Poppins', sans-serif",
                                        color: '#808080',
                                        borderRadius: '7px'
                                    }}
                                    value="">Select Operation</option>
                                <option value="add">Add</option>
                                <option value="update">Update</option>
                                <option value="delete">Delete</option>
                            </select>
                        </div>
                    </div>

                </div>
                <div className="activityLogContainer" ref={componentRef}>
                    <div className="activityLogsVisibility">Activity Logs</div>
                    <div className="activityLogsFilters">
                        {/* if filter are applied then only display */}
                        {
                            userActivityFromDate.length !== 0 || userActivityToDate.length !== 0 || moduleId.length !== 0 || operation !== '' && (
                                <>
                                    Filters are Applied:
                                    {userActivityFromDate.length !== 0 && <span> From date: {userActivityFromDate}, </span>}
                                    {userActivityToDate.length !== 0 && <span> To date: {userActivityToDate}, </span>}
                                    {moduleId.length !== 0 && <span> Module: {moduleId}, </span>}
                                    {operation !== '' && <span> Operation: {operation} </span>}
                                </>
                            )
                        }


                    </div>
                    <div
                        className='pr-2 d-flex flex-column workspace-current-modal-mode'
                        style={{ height: 'calc(100% - 100px)' }}

                    >
                        {UserActivityList.length === 0 ? (
                            <span>No new activities.</span>
                        ) : (
                            <>
                                {isLoading ? (
                                    <span className="align-self-center font-weight-bold">
                                        Loading Activities . . .&nbsp;
                                        <FontAwesomeIcon icon={['fas', 'circle-notch']} className="rotate" />
                                    </span>
                                ) : (
                                    <div className="table-responsive col-md-12 scrollable-div"
                                        style={{ width: '100%', marginTop: '20px', minHeight: '60vh' }}>
                                        <table className="table table-bordered workspace-current-modal-mode" id="UserActivityData"
                                            style={{ width: '100%', borderCollapse: 'collapse', border: '1.01px solid #E0E8EF' }}>
                                            <thead
                                                className="ws-vm-table-header"
                                                style={{
                                                    position: 'sticky',
                                                    top: '-1%',
                                                    zIndex: 1,
                                                    borderBottom: '1px solid #E0E8EF',
                                                    backgroundColor: "#f3f3f3"
                                                }}
                                            >
                                                <tr>
                                                    <th style={{ padding: '12px 12px', border: '1.01px solid #E0E8EF' }}>
                                                        <p className='vm_custom_body16'>Sr. No</p>
                                                    </th>
                                                    <th style={{ padding: '12px 12px', border: '1.01px solid #E0E8EF' }}>
                                                        <p className='vm_custom_body16'>Module</p>
                                                    </th>
                                                    <th style={{ padding: '12px 12px', border: '1.01px solid #E0E8EF' }}>
                                                        <p className='vm_custom_body16'>Activity</p>
                                                    </th>
                                                    <th style={{ padding: '12px 12px', border: '1.01px solid #E0E8EF' }}>
                                                        <p className='vm_custom_body16'>Date & Time</p>
                                                    </th>
                                                    <th style={{ padding: '12px 12px', border: '1.01px solid #E0E8EF' }}>
                                                        <p className='vm_custom_body16'>Operation</p>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody style={{ overflowY: 'auto' }}>
                                                {sortedIdArray?.length > 0 ? (
                                                    sortedIdArray.map((id, index) => {
                                                        let userActivity = UserActivityList[id];
                                                        if (userActivity) {
                                                            return (
                                                                <tr key={id}>
                                                                    <td className="table-rows vm_custom_body5"
                                                                        style={{ border: '1.01px solid #E0E8EF' }}>
                                                                        {(pageIndex - 1) * limit + index + 1}
                                                                    </td>
                                                                    <td className="table-rows vm_custom_body5"
                                                                        style={{ border: '1.01px solid #E0E8EF' }}
                                                                        title={userActivity.moduleName}>
                                                                        {userActivity.moduleName}
                                                                    </td>
                                                                    <td className="table-rows vm_custom_body5"
                                                                        style={{ border: '1.01px solid #E0E8EF',wordBreak:"break-all",whiteSpace:"normal"}}
                                                                        title={userActivity.action_performed}>
                                                                            {userActivity.action_performed}
                                                                            {/* {
                                                                                isExporting ? userActivity.action_performed : 
                                                                                (userActivity.action_performed.length > 50 ? userActivity.action_performed.slice(0, 50) + "..." : userActivity.action_performed)
                                                                            } */}
                                                                    </td>
                                                                    <td className="table-rows vm_custom_body5"
                                                                        style={{ border: '1.01px solid #E0E8EF' }}
                                                                        title={userActivity.addedOn}>
                                                                        {userActivity.addedOn}
                                                                    </td>
                                                                    <td className="table-rows vm_custom_body5"
                                                                        style={{ border: '1.01px solid #E0E8EF' }}>
                                                                        <span style={{
                                                                            backgroundColor: userActivity.operation?.toLowerCase() === 'add' ? '#D2FFD2'
                                                                                : userActivity.operation?.toLowerCase() === "update" ? '#FFDE9E'
                                                                                    : '#FF9E9E',
                                                                            borderRadius: '50px',
                                                                            alignSelf: 'center',
                                                                            height: '1.5rem',
                                                                            width: 'auto',
                                                                            padding: '0.425rem 0.9375rem',

                                                                            color: userActivity.operation?.toLowerCase() === 'add' ? '#008000'
                                                                                : userActivity.operation?.toLowerCase() === "update" ? '#D88E00'
                                                                                    : '#FC3333',
                                                                        }}>
                                                                            {userActivity.operation?.toLowerCase() === 'add' ? 'Added'
                                                                                : userActivity.operation?.toLowerCase() === 'update' ? 'Updated'
                                                                                    : 'Deleted'}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }
                                                        return null;
                                                    })
                                                ) : (
                                                    <tr style={{ height: '27.5rem' }}>
                                                        <td
                                                            className="table-rows vm_custom_body5"
                                                            colSpan={9}
                                                            style={{
                                                                textAlign: 'center',
                                                                verticalAlign: 'middle',
                                                                height: '100%',
                                                            }}
                                                        >
                                                            <p className="vm_custom_body5" style={{ textAlign: 'center' }}>
                                                                Tasks not found
                                                            </p>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                            <tfoot className="hideWhenPrint border" style={{ position: 'sticky', bottom: '-1%', backgroundColor: "white" }}>
                                                <tr>
                                                    <td colSpan="9" style={{ padding: 0, border: 'none', alignItems: 'center' }}>
                                                        <div className="ws-vm-table-header" style={{
                                                            display: 'flex', height: '42px',
                                                            justifyContent: 'space-between', flexDirection: 'row',
                                                            alignItems: 'center', borderRadius: '0.69px', paddingRight: '16px'
                                                        }}>
                                                            <div className="ml-3">
                                                                <select
                                                                    className="ws-vm-table-header"
                                                                    style={{
                                                                        height: '24px',
                                                                        width: 'auto',
                                                                        borderRadius: 'none',
                                                                        border: 'none',
                                                                        outline: 'none',
                                                                    }}
                                                                    value={limit}
                                                                    onChange={(e) => resetUserList(e)
                                                                    }
                                                                >
                                                                    <option value={10} className='vm_custom_body6'>Entries Per Page 10</option>
                                                                    <option value={25} className='vm_custom_body6'>Entries Per Page 25</option>
                                                                    <option value={40} className='vm_custom_body6'>Entries Per Page 40</option>
                                                                    <option value={100} className='vm_custom_body6'>Entries Per Page 100</option>
                                                                    <option value={250} className='vm_custom_body6'>Entries Per Page 250</option>
                                                                </select>
                                                            </div>

                                                            <div id="paginationContainer">
                                                                <Pagination
                                                                    activePage={pageIndex}
                                                                    itemsCountPerPage={limit}
                                                                    totalItemsCount={totalCount}
                                                                    pageRangeDisplayed={4}
                                                                    onChange={updatePaginationCount}  // ✅ Correct way to pass the function

                                                                />
                                                            </div>
                                                            <span style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                <label className="vm_custom_title4 m-0">Total Records :</label>
                                                                <label className="vm_custom_title4 m-0" style={{ fontSize: '15px' }}>
                                                                    {totalCount}
                                                                </label>
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div >

    )
}

export default UserActivityPanel;
